import { makeAPIRequest } from '@/helpers/searchUtils'
import { fetchApi } from './fetchApi'
import { SearchDataProps } from '@/components/search/_types/searchDataType'

interface FetchMainQueryLandingParams {
  query: { [key: string]: any }
  req?: { [key: string]: any }
  perPage?: number
  pageContent: 'cottage' | 'boomgardi'
}

export const fetchMainQueryLanding = async ({
  query,
  req = {},
  perPage = 24,
  pageContent,
}: FetchMainQueryLandingParams): Promise<SearchDataProps> => {
  const { apiParams } = makeAPIRequest({
    queryParams: {
      ...query,
      [pageContent]: 1,
    },
    perPage,
  })

  const initialData: SearchDataProps = {
    list: [],
    map_list: [],
    midterm_map_list: null,
    region_data: null,
    pagination: {
      total: 1,
      current_page: 1,
    },
    search_id: '',
    min_price: {
      amount: '30000',
      currency_name: 'تومان',
      currency_short_form: 'ت',
    },
    parent: null,
    discount_motivation: null,
  }

  try {
    const res = await fetchApi(
      '/house/search',
      {
        ...apiParams,
        'with[]': 'photos',
      },
      req,
    )
    const data: SearchDataProps = {
      list: res?.data?.records,
      min_price: !res?.data?.min_price?.amount
        ? {
            amount: 30000,
            currency_name: 'تومان',
            currency_short_form: 'ت',
          }
        : res?.data?.min_price,
      pagination: res?.data?.pagination,
      region_data: res?.data?.region_data,
      parent: res?.data?.parent,
      search_id: res?.data?.search_id,
      map_list: res?.data?.records,
      midterm_map_list: res?.data?.records,
      discount_motivation: res?.data?.discount_motivation,
    }
    return res ? data : initialData
  } catch (error) {
    return initialData
  }
}
